import accountAPI from '../../api/Account'
import * as types from '../mutation-types'
import {http} from "../../api/__http";
import downloadAPI from "../../api/Download";

// initial state
const state = {
    isLoggedIn: !!localStorage.getItem('ra_token'),
    user: {
        firstName: localStorage.getItem('ra_firstName'),
        lastName: localStorage.getItem('ra_lastName'),
        role: localStorage.getItem('ra_role'),
        impersonated: !!localStorage.getItem('ra_impersonated'),
        customerKey: localStorage.getItem('ra_customerKey'),
        customerName: localStorage.getItem('ra_customerName'),
        customerCurrencyCode: localStorage.getItem('ra_customerCurrencyCode'),
        customerCurrencySymbol: localStorage.getItem('ra_customerCurrencySymbol'),
        userName: localStorage.getItem('ra_userName')
    },
    userData: {},
    employees: [],
    users: [],
    customerOrders: [],
    customerBackOrders: [],
    customerInvoices: [],
    historyOrderDetail: {},
    deliveryAddress: [],
    invoiceAddress: [],
    shopAddress: [],
    dealerLocatorAddress: [],
    customerHidden: localStorage.getItem('ra_customerHidden') === 'true',
    salesmen: []
}

// getters
const getters = {
    isLoggedIn: state => { return state.isLoggedIn },
    isAdmin: state => { return state.user.role === 'Admin' },
    isSalesman: state => { return state.user.role === 'Vertegenwoordiger' },
    isCustomer: state => { return state.user.role === 'Klant' },
    isPersoneel: state => { return state.user.role === 'PersoneelKlant' },
    isMarketing: state => { return state.user.role === 'MarketingKlant' },
    isImpersonated: state => { return state.user.impersonated === true },
    isCustomerHidden: state => { return state.customerHidden },

    userInfo: state => { return state.user },
    userPersonalData: state => { return state.userData },
    customerOrders: state => { return state.customerOrders },
    customerBackOrders: state => { return state.customerBackOrders },
    customerInvoices: state => { return state.customerInvoices },
    historyOrderDetail: state => { return state.historyOrderDetail },
    Employees: state => { return state.employees },
    Users: state => { return state.users },

    deliveryAddress: state => { return state.deliveryAddress; },
    invoiceAddress: state => { return state.invoiceAddress; },
    shopAddress: state => { return state.shopAddress; },
    dealerLocatorAddress: state => { return state.dealerLocatorAddress; },
    salesmen: state => { return state.salesmen; }
}

// actions
const actions = {
    login({ commit }, creds) {
        commit(types.LOGIN);
        return new Promise((resolve, reject) => {
            accountAPI.userLogin(user => {
                if (user.status > 300) {
                    reject(user.data);
                } else {
                    resolve(user)
                    commit(types.LOGIN_SUCCESS, user)
                }
            }, creds)
        });
    },
    logout({ commit }) {
        localStorage.clear();
        commit(types.LOGOUT);
    },
    checkAuth({ commit }) {
        commit(types.CHECK_AUTH);
    },
    impersonateUser({ commit }, customer) {
        return new Promise((resolve, reject) => {
            accountAPI.impersonateUser(user => {
                if (user.status > 300) {
                    reject(user.data);
                } else {
                    commit(types.IMPERSONATE, user)
                    resolve(user)
                }
            }, customer)
        });
    },
    revertImpersonate({ commit }) {
        return new Promise(resolve => {
            accountAPI.revertImpersonate(user => {
                commit(types.REVERT_IMPERSONATE, user)
                resolve(user)
            })
        });
    },
    disableCustomerIsWatching({ commit }, params) {
        return new Promise(resolve => {
            accountAPI.disableCustomerIsWatching(user => {
                commit(types.CUSTOMER_HIDDEN)
                resolve(user)
            }, params)
        });
    },
    register({ commit } , params) {
        return new Promise(resolve => {
            accountAPI.register(user => {
                resolve(user)
            }, params)
        });
    },
    confirmEmail({ commit }, params) {
        return new Promise(resolve => {
           accountAPI.confirmEmail(user => {
               resolve(user)
           }, params)
        });
    },
    getUser({ commit }) {
        return new Promise((resolve, reject) => {
            accountAPI.getUser(user => {
                if (user.status > 300) {
                    reject(user.data);
                } else {
                    commit(types.RECEIVE_USER, user)
                    resolve(user)
                }
            })
        });
    },
    getUserById({commit}, id) {
        return new Promise((resolve, reject) => {
            accountAPI.getUserById(user => {
                if(user.status > 300) {
                    reject(user.data);
                } else {
                    resolve(user);
                }
            }, id);
        });
    },
    sendUser({ commit }, params) {
        return new Promise((resolve, reject) => {
            accountAPI.sendUser(user => {
                if (user.status > 300) {
                    reject(user.data);
                } else {
                    resolve(user)
                }
            }, params)
        });
    },
    changePassword({ commit }, params) {
        return new Promise((resolve, reject) => {
            accountAPI.changePassword(user => {
                if (user.status > 300) {
                    reject(user.data);
                } else {
                    resolve(user)
                }
            }, params)
        });
    },
    forgotPassword({ commit }, params) {
        return new Promise((resolve, reject) => {
            accountAPI.forgotPassword(user => {
                if (user.status > 300) {
                    reject(user.data);
                } else {
                    resolve(user)
                }
            }, params)
        });
    },
    resetPassword({ commit }, params) {
        return new Promise((resolve, reject) => {
            accountAPI.resetPassword(user => {
                if (user.status > 300) {
                    reject(user.data);
                } else {
                    resolve(user)
                }
            }, params)
        });
    },
    getCustomerOrders ({ commit }, params){
        return new Promise((resolve, reject) => {
            accountAPI.getCustomerOrders(orders => {
                if (orders.status > 300) {
                    reject(orders.data);
                } else {
                    commit(types.RECEIVE_CUSTOMER_ORDERS, { orders })
                    resolve(orders)
                }
            }, params)
        })
    },
    getCustomerBackOrders ({ commit }, params){
        return new Promise((resolve, reject) => {
            accountAPI.getCustomerBackOrders(backorders => {
                if (backorders.status > 300) {
                    reject(backorders.data);
                } else {
                    commit(types.RECEIVE_CUSTOMER_BACKORDERS, { backorders })
                    resolve(backorders)
                }
            }, params)
        })
    },
    getCustomerInvoices ({ commit }, params){
      return new Promise((resolve, reject) => {
        accountAPI.getCustomerInvoices(invoices => {
          if (invoices.status > 300) {
            reject(invoices.data);
          } else {
            commit(types.RECEIVE_CUSTOMER_INVOICES, { invoices })
            resolve(invoices)
          }
        }, params)
      })
  },
    getEmployees ({ commit }){
        return new Promise((resolve, reject) => {
            accountAPI.getEmployees(employees => {
                if (employees.status > 300) {
                    reject(employees.data);
                } else {
                    commit(types.RECEIVE_EMPLOYEES, { employees })
                    resolve(employees)
                }
            })
        })
    },
    searchUsers ({ commit }, params){
        return new Promise((resolve, reject) => {
            accountAPI.searchUsers(users => {
                if(users.status > 300) {
                    reject(users.data);
                } else {
                    commit(types.RECEIVE_USERS, { users })
                    resolve(users)
                }
            }, params)
        })
    },
    getHistoryOrderDetail({ commit }, params){
        return new Promise((resolve) => {
            accountAPI.getHistoryOrderDetail(orderDetail => {
                commit(types.RECEIVE_HISTORY_ORDER_DETAIL, { orderDetail })
                resolve()
            }, params)
        })
    },
    downloadImages({ commit }, id){
        return new Promise((resolve) => {
            accountAPI.downloadImages(images => {
                resolve(images)
            }, id)
        })
    },
    downloadOrderLinesCsv({ commit }, id){
        return new Promise((resolve) => {
            accountAPI.downloadOrderLinesCsv(csv => {
                resolve(csv)
            }, id)
        })
    },
    downloadSheet({ commit }, id){
        return new Promise((resolve) => {
            accountAPI.downloadSheet(pdf => {
                resolve(pdf)
            }, id)
        })
    },
    reOrder({ commit }, params) {
        return new Promise((resolve) => {
            accountAPI.reOrder(result => {
                if (result.status > 300) {
                    reject(result);
                } else {
                    resolve(result)
                }
            }, params)
        })
    },
    requestInvoice({ commit }, id) {
        return new Promise((resolve) => {
            accountAPI.requestInvoice(result => {
                if (result.status > 300) {
                    reject(result);
                } else {
                    resolve(result)
                }
            }, id)
        })
    },
    deleteUser({ commit }, email) {
        return new Promise((resolve, reject) => {
            accountAPI.deleteUser(result => {
                if(result.status > 300) {
                    reject(result);
                } else {
                    resolve(result);
                }
            }, email)
        })
    },

    // CUSTOMER ADDRESSES
    sendAddress({ commit }, params){
        return new Promise((resolve, reject) => {
            accountAPI.sendAddress(address => {
                resolve(address);
            }, params)
        })
    },
    deleteAddress({ commit }, params){
        return new Promise((resolve, reject) => {
            accountAPI.deleteAddress(address => {
                if (address.status > 300) { reject(address.data); } else { resolve(address) }
            }, params)
        })
    },

    getDeliveryAddress({ commit }, customer){
        return new Promise((resolve) => {
            accountAPI.getDeliveryAddress(address => {
                commit(types.RECEIVE_DELIVERY_ADDRESS, { address })
                resolve()
            }, customer)
        })
    },
    getInvoiceAddress({ commit }, customer){
        return new Promise((resolve) => {
            accountAPI.getInvoiceAddress(address => {
                commit(types.RECEIVE_INVOICE_ADDRESS, { address })
                resolve()
            }, customer)
        })
    },
    getShopAddress({ commit }, customer){
        return new Promise((resolve) => {
            accountAPI.getShopAddress(address => {
                commit(types.RECEIVE_SHOP_ADDRESS, { address })
                resolve()
            }, customer)
        })
    },
    getDealerLocatorAddress({ commit }, customer){
        return new Promise((resolve) => {
            accountAPI.getDealerLocatorAddress(address => {
                commit(types.RECEIVE_DEALERLOCATOR_ADDRESS, { address })
                resolve()
            }, customer)
        })
    },
    showOnDealerLocator({ commit }, params){
        return new Promise((resolve) => {
            accountAPI.showOnDealerLocator(address => {
                resolve(address)
            }, params)
        })
    },
    hideOnDealerLocator({ commit }, id){
        return new Promise((resolve) => {
            accountAPI.hideOnDealerLocator(address => {
                resolve(address)
            }, id)
        })
    },
    editCustomerKey({commit}, params){
        return new Promise((resolve, reject) => {
            accountAPI.editCustomerKey((customer) => {
                if(customer.status > 300) {
                    reject(customer.data);
                } else{
                    resolve(customer)
                }
            }, params)
        })
    },

    //WARRANTY
    requestWarranty({ commit }, request) {
        return new Promise((resolve) => {
            accountAPI.requestWarranty(response => {
                resolve(response)
            }, request)
        })
    },

    customerHidden({ commit }) {
        return new Promise((resolve) => {
            accountAPI.customerIsWatching(response => {
                resolve(response)
                commit(types.CUSTOMER_HIDDEN)
            })
        })
    },

    sendContactForm({ commit }, params){
        return new Promise((resolve, reject) => {
            accountAPI.sendContactForm(contact => {
                if (contact.status > 300) { reject(contact.data); } else { resolve(contact) }
            }, params)
        })
    },

    //PREORDERSHEET REPORTS
    getSalesmen({ commit }, search){
        return new Promise((resolve) => {
            accountAPI.getSalesmen(salesmen => {
                resolve(salesmen)
                commit(types.RECEIVE_SALESMEN, { salesmen })
            }, search)
        })
    }

}

// mutations
const mutations = {
    [types.LOGIN] (state) {
        state.pending = true
    },
    [types.LOGIN_SUCCESS] (state, user) {
        state.isLoggedIn = true
        state.pending = false

        // Set to state for first time
        state.user.firstName = user.firstName;
        state.user.lastName = user.lastName;
        state.user.role = user.role;
        state.user.customerKey = user.customerKey;
        state.user.customerName = user.customerName;
        state.user.customerCurrencyCode = user.customerCurrencyCode;
        state.user.customerCurrencySymbol = user.customerCurrencySymbol;
        state.user.userName = user.userName;

        var customerIsWatching = (user.customerIsWatching == 'true');
        state.customerHidden = customerIsWatching;

        // Add to localStorage
        localStorage.setItem("ra_firstName", user.firstName);
        localStorage.setItem("ra_lastName", user.lastName);
        localStorage.setItem("ra_role", user.role);
        localStorage.setItem("ra_token", user.access_token);
        localStorage.setItem("ra_userid", user.id);
        localStorage.setItem("ra_customerKey", user.customerKey);
        localStorage.setItem("ra_customerName", user.customerName);
        localStorage.setItem("ra_customerCurrencyCode", user.customerCurrencyCode);
        localStorage.setItem("ra_customerCurrencySymbol", user.customerCurrencySymbol);
        localStorage.setItem("ra_userName", user.userName);
        localStorage.setItem("ra_customerHidden", customerIsWatching);
    },
    [types.IMPERSONATE] (state, user) {
        state.user.firstName = user.FirstName;
        state.user.lastName = user.LastName;
        state.user.role = user.Role;
        state.user.impersonated = true;
        state.user.customerKey = user.CustomerKey;
        state.user.customerName = user.CustomerName;
        state.user.customerCurrencyCode = user.CustomerCurrencyCode;
        state.user.customerCurrencySymbol = user.CustomerCurrencySymbol;
        state.user.userName = user.UserName;

        var customerIsWatching = (user.CustomerIsWatching == 'true');
        state.customerHidden = customerIsWatching;

        // Add to localStorage
        localStorage.setItem("ra_firstName", user.FirstName);
        localStorage.setItem("ra_lastName", user.LastName);
        localStorage.setItem("ra_role", user.Role);
        localStorage.setItem("ra_token", user.AccessToken);
        localStorage.setItem("ra_userid", user.Id);
        localStorage.setItem("ra_impersonated", true);
        localStorage.setItem("ra_customerKey", user.CustomerKey);
        localStorage.setItem("ra_customerName", user.CustomerName);
        localStorage.setItem("ra_customerCurrencyCode", user.CustomerCurrencyCode);
        localStorage.setItem("ra_customerCurrencySymbol", user.CustomerCurrencySymbol);
        localStorage.setItem("ra_userName", user.UserName);
        localStorage.setItem("ra_customerHidden", customerIsWatching);
    },
    [types.REVERT_IMPERSONATE] (state, user) {
        state.user.firstName = user.FirstName;
        state.user.lastName = user.LastName;
        state.user.role = user.Role;
        state.user.impersonated = false;
        state.user.customerKey = user.customerKey;
        state.user.customerName = user.customerName;
        state.user.customerCurrencyCode = user.customerCurrencyCode;
        state.user.customerCurrencySymbol = user.customerCurrencySymbol;
        state.user.userName = user.userName;

        var customerIsWatching = (user.CustomerIsWatching == 'true');
        state.customerHidden = customerIsWatching;

        // Add to localStorage
        localStorage.setItem("ra_firstName", user.FirstName);
        localStorage.setItem("ra_lastName", user.LastName);
        localStorage.setItem("ra_role", user.Role);
        localStorage.setItem("ra_token", user.AccessToken);
        localStorage.setItem("ra_userid", user.Id);
        localStorage.setItem("ra_customerKey", user.CustomerKey);
        localStorage.setItem("ra_customerName", user.CustomerName);
        localStorage.setItem("ra_customerCurrencyCode", user.CustomerCurrencyCode);
        localStorage.setItem("ra_customerCurrencySymbol", user.CustomerCurrencySymbol);
        localStorage.setItem("ra_userName", user.UserName);
        localStorage.setItem("ra_customerHidden", customerIsWatching);

        localStorage.removeItem("ra_impersonated");
    },
    [types.LOGOUT] (state) {
        state.isLoggedIn = false
        state.user.impersonated = false
    },
    [types.CHECK_AUTH] () {
        http.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('ra_token');
    },
    [types.RECEIVE_USER] (state, user) {
        state.userData = user;
    },
    [types.RECEIVE_CUSTOMER_ORDERS] (state, { orders }){
        state.customerOrders = orders;
    },
    [types.RECEIVE_CUSTOMER_BACKORDERS] (state, { backorders }){
        state.customerBackOrders = backorders;
    },
    [types.RECEIVE_CUSTOMER_INVOICES] (state, { invoices }){
      state.customerInvoices = invoices;
    },
    [types.RECEIVE_EMPLOYEES] (state, employees) {
        state.employees = employees.employees;
    },
    [types.RECEIVE_USERS] (state, users) {
        state.users = users.users
    },
    [types.RECEIVE_HISTORY_ORDER_DETAIL] (state, { orderDetail }){
        state.historyOrderDetail = orderDetail
    },

    // CUSTOMER ADDRESSES
    [types.RECEIVE_DELIVERY_ADDRESS] (state, { address }){
        state.deliveryAddress = address;
    },
    [types.RECEIVE_INVOICE_ADDRESS] (state, { address }){
        state.invoiceAddress = address;
    },
    [types.RECEIVE_SHOP_ADDRESS] (state, { address }){
        state.shopAddress = address;
    },
    [types.RECEIVE_DEALERLOCATOR_ADDRESS] (state, { address }){
        state.dealerLocatorAddress = address;
    },

    // CUSTOMER HIDDEN
    [types.CUSTOMER_HIDDEN] (state) {
        state.customerHidden = !state.customerHidden;
        localStorage.setItem("ra_customerHidden", state.customerHidden);
    },

    // PREORDERSHEET REPORTS
    [types.RECEIVE_SALESMEN] (state, { salesmen }) {
        state.salesmen = salesmen;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/Account.js